import React, { useRef, useState, useEffect, useContext } from 'react';
import { Button, Tooltip } from '@mantine/core';
import { MdOutlineCloudUpload } from "react-icons/md";
import useFetch from '../../Customhooks/useFetch';
import { notifications } from '@mantine/notifications';
import { authContext } from '../../context/AuthProvider.component';

interface InputButtonProps {
    url: string;
}

const InputButton = ({ url }: InputButtonProps) => {
    const [value, setValue] = useState<File | null>(null);
    const token = localStorage.getItem('token');
    const { triggerRefresh }: any = useContext(authContext);      

    const formData = new FormData();
    if (value) {
        formData.append('file', value);
    }

    const {
        data: getData,
        loading: detailLoading,
        error: getError,
        fetchData: postfile,
    } = useFetch({
        method: 'POST',
        referrerPolicy: 'no-referrer',
        headers: {
            'Access-Control-Allow-Origin': '*',
            token: token || '',
        },
        body: formData,
    });

    const fileInputRef = useRef<HTMLInputElement | null>(null);

    const handleButtonClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            setValue(file);
        }
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };

    useEffect(() => {
        if (value && url) {
            postfile(url);
        }
    }, [value, url]);

    useEffect(() => {
        const showNotification = (type: any, title = "An error occurred") => {
            notifications.show({
                title,
                message: type === 'success'
                    ? "Upload successfully."
                    : "Something went wrong. Please try again.",
                color: type === 'success' ? "green" : "red",
            });
        };

        if (getData?.errors || getError) {
            showNotification('error', getData?.message || getError?.message);
            return;
        }
        if (getData?.message) {
            triggerRefresh((prev:any) => !prev)
            showNotification('success', getData?.message);
            return;
        }
    }, [getData, getError]);

    return (
        <>
                <input
                    type="file"
                    ref={fileInputRef}
                    style={{ display: 'none' }}
                    onChange={handleFileChange}
                />
            <Tooltip label="Upload Data (csv, xlsx)" color="#404040">
                <Button
                    variant="filled"
                    loading={detailLoading}
                    loaderProps={{ type: 'oval' }}
                    color="#404040"
                    onClick={handleButtonClick}
                >
                    <MdOutlineCloudUpload size={30} />
                </Button>
            </Tooltip>
        </>
    );
};

export default InputButton;
